// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';
import { prepareUrl } from './common';

/**
 * @class Jsw.Button
 * @extends Jsw.Component
 *
 * Example usage:
 *
 *     @example
 *     new Jsw.Button({
 *         renderTo: document.body,
 *         title: 'Add a Customer',
 *         cls: 's-btn sb-add-new-customer',
 *         isNew: true,
 *         newTitle: 'New',
 *         handler: function () {
 *             alert('You clicked the button!');
 *         }
 *     });
 */
export const Button = Class.create(Component, {
    _tag: 'a',

    /**
     * @cfg {String} title=""
     */
    /**
     * @cfg {String} rightIcon=""
     */
    /**
     * @cfg {String|Function} handler
     */
    /**
     * @cfg {String} href
     */
    /**
     * @cfg {String} target
     */
    /**
     * @cfg {String} disabledClass=btn-disabled
     */
    /**
     * @cfg {Boolean} isNew=false
     */
    /**
     * @cfg {String} newTitle=""
     */

    _initConfiguration($super, config) {
        $super(config);

        this._handler = this._getConfigParam('handler', false);
        if (Object.isString(this._handler)) {
            // eslint-disable-next-line no-eval
            eval(`this._handler = ${this._handler}`);
        }
        this._title = this._getConfigParam('title', '');
        this._rightIcon = this._getConfigParam('rightIcon', '');
        this._cls = this._getConfigParam('cls', `b-btn${!this._title ? ' btn-icon-only' : ''}`);
        this._disabledClass = this._getConfigParam('disabledClass', 'btn-disabled');
        this._isNew = this._getConfigParam('isNew', false);
        this._newTitle = this._getConfigParam('newTitle', '');
    },

    _initComponentElement($super) {
        $super();

        this._componentElement.update(
            '<i><i><i>' +
                `<span>${this._title.escapeHTML()}${this._isNew ? ` <span class="badge-new">${this._newTitle}</span>` : ''}${this._rightIcon}</span>` +
            '</i></i></i>'
        );

        this._initVisibility();
    },

    _initVisibility() {
        this._disabled = this._getConfigParam('disabled', false);

        if (this._disabled) {
            this._disabled = false;
            this.disable();
        } else {
            this._disabled = true;
            this.enable();
        }
    },

    _addAttribute(name, value) {
        if ('undefined' !== typeof value) {
            this._componentElement.writeAttribute(name, value);
        }
    },

    enable() {
        if (!this._disabled) {
            return;
        }
        this._disabled = false;

        let classNames = this._config.addCls || '';
        if (!Object.isArray(classNames)) {
            classNames = [classNames];
        }
        classNames.each(function (item) {
            this._componentElement.addClassName(item);
        }, this);
        classNames.each(function (item) {
            this._componentElement.removeClassName(`${item}-disabled`);
        }, this);
        this._componentElement.removeClassName(this._disabledClass);

        this._addAttribute('href', prepareUrl(this._getConfigParam('href', 'javascript:;')));
        this._addAttribute('target', this._getConfigParam('target', null));

        this._addProgressHandler();
        if (this._handler) {
            this.addEventObserver('click', this._handler);
        }
    },

    disable() {
        if (this._disabled) {
            return;
        }
        this._disabled = true;

        this._componentElement.addClassName(this._disabledClass);

        let classNames = this._config.addCls;
        if (!Object.isArray(classNames)) {
            classNames = [classNames];
        }
        classNames.each(function (item) {
            this._componentElement.addClassName(`${item}-disabled`);
        }, this);
        classNames.each(function (item) {
            this._componentElement.removeClassName(item);
        }, this);
        this._componentElement.writeAttribute('href', null);
        this._componentElement.writeAttribute('target', null);

        if (this._handler) {
            this.removeEventObserver('click', this._handler);
        }
    },

    _addProgressHandler() {
    },
});



// WEBPACK FOOTER //
// ./jsw/button.js